import { render, staticRenderFns } from "./BaseStationPage.vue?vue&type=template&id=33782fda&scoped=true&"
import script from "./BaseStationPage.vue?vue&type=script&lang=ts&"
export * from "./BaseStationPage.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStationPage.vue?vue&type=style&index=0&id=33782fda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33782fda",
  null
  
)

export default component.exports